'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrustIndicator {
  icon: string;
  label: string;
  value: string;
}

interface TrustIndicatorBarProps {
  className?: string;
}

const TrustIndicatorBar = ({ className = '' }: TrustIndicatorBarProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const trustIndicators: TrustIndicator[] = [
    {
      icon: 'ShieldCheckIcon',
      label: 'FSSAI Certified',
      value: 'License No. 22725646000040',
    },
    {
      icon: 'CheckBadgeIcon',
      label: '100% Organic',
      value: 'Certified by India Organic',
    },
    {
      icon: 'UserGroupIcon',
      label: 'Trusted by',
      value: '5000+ Families',
    },
    {
      icon: 'TruckIcon',
      label: 'Free Shipping',
      value: 'On orders above ₹999',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % trustIndicators.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`bg-muted ${className}`}>
      <div className="mx-auto max-w-[1200px] px-6">
        <div className="hidden items-center justify-between gap-6 py-3 lg:flex">
          {trustIndicators.map((indicator, index) => (
            <div
              key={index}
              className="flex items-center gap-2 transition-opacity duration-250 ease-out"
            >
              <Icon
                name={indicator.icon as any}
                size={20}
                className="text-primary"
              />
              <div className="flex items-baseline gap-1">
                <span className="text-sm font-medium text-muted-foreground">
                  {indicator.label}
                </span>
                <span className="text-sm font-bold text-foreground">
                  {indicator.value}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center py-3 lg:hidden">
          <div className="flex items-center gap-2">
            <Icon
              name={trustIndicators[currentIndex].icon as any}
              size={20}
              className="text-primary"
            />
            <div className="flex items-baseline gap-1">
              <span className="text-sm font-medium text-muted-foreground">
                {trustIndicators[currentIndex].label}
              </span>
              <span className="text-sm font-bold text-foreground">
                {trustIndicators[currentIndex].value}
              </span>
            </div>
          </div>
        </div>

        <div className="flex justify-center gap-1.5 pb-2 lg:hidden">
          {trustIndicators.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`h-1.5 rounded-full transition-all duration-250 ease-out ${
                index === currentIndex
                  ? 'w-6 bg-primary' :'w-1.5 bg-border hover:bg-primary/50'
              }`}
              aria-label={`Go to indicator ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustIndicatorBar;